import React from 'react';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import SOorMDOPreActivity from '../preActivitySOMDO/index.jsx';
import SOorMDOPostActivity from '../postActivitySOMDO/index.jsx';
import SOorMDOSalesTarget from '../salesTargetSOMDO/index.jsx';

function ActivitiesTabs() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const [tab, setTab] = React.useState('pre');

  // Ensure sm/md behave as before: no tabs page, redirect to preActivity
  React.useEffect(() => {
    if (!isXs) {
      navigate('/SOorMDO/preActivity', { replace: true });
    }
  }, [isXs, navigate]);

  const tabs = [
    { key: 'pre', label: 'Pre Activity' },
    { key: 'post', label: 'Post Activity' },
    { key: 'sales', label: 'Sale Activity' },
  ];

  if (!isXs) return null;

  return (
    <Box>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          p: 0.75,
          borderRadius: 9999,
          mt:{ xs: 8, sm: 0 },
          bgcolor: '#fff',
          border: '1px solid',
          borderColor: 'rgba(67, 24, 255, 0.15)',
          boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04)',
        }}
      >
        {tabs.map((t) => {
          const selected = tab === t.key;
          return (
            <Button
              key={t.key}
              onClick={() => setTab(t.key)}
              size={'small'}
              sx={{
                minWidth: 0,
                px: 2,
                py: 0.75,
                borderRadius: 9999,
                textTransform: 'none',
                fontSize: '0.9rem',
                color: selected ? '#fff' : '#000',
                bgcolor: selected ? '#4318FF' : 'transparent',
                boxShadow: selected ? '0px 8px 18px rgba(67, 24, 255, 0.35)' : 'none',
                '&:hover': {
                  bgcolor: selected ? '#3a12f0' : 'transparent',
                },
              }}
            >
              {t.label}
            </Button>
          );
        })}
      </Box>

      <Box sx={{ mt: 2 }}>
        {tab === 'pre' && <SOorMDOPreActivity />}
        {tab === 'post' && <SOorMDOPostActivity />}
        {tab === 'sales' && <SOorMDOSalesTarget />}
      </Box>
    </Box>
  );
}

export default ActivitiesTabs;
